export {default} from './CustomText';
export {CustomTextContentfulComponentDefinition} from './CustomTextContentfulDefinition';
